<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Videos</h5>
          <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              v-on:click="$emit('update:show', false)"
          >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                  d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div>
            <div class="row">
              <div class="col-3 text-start">
                <button
                  class="btn w-100 d-block"
                  v-on:click="uploadMenu = true"
                  :class="{
                    'btn-primary': uploadMenu,
                    'btn-simple': !uploadMenu,
                  }"
                >
                  Upload file
                </button>
                <button
                  class="btn w-100 d-block"
                  v-on:click="uploadMenu = false"
                  :class="{
                    'btn-primary': !uploadMenu,
                    'btn-simple': uploadMenu,
                  }"
                >
                  Browse gallery
                </button>
              </div>
              <div class="col" v-if="uploadMenu">
                <file-pond
                  name="video"
                  ref="pond"
                  label-idle="Drop files here..."
                  v-bind:allow-multiple="true"
                  accepted-file-types="video/mp4, video/x-msvideo, video/quicktime, video/ogg, video/webm"
                  v-bind:files="myFiles"
                  v-on:init="handleFilePondInit"
                  :server="server"
                  :chunkUploads="true"
                  :chunkForce="true"
                  :chunkSize="1000000"
                  :credits="false"
                />
              </div>
              <div class="col" v-else>
                <div class="row">
                  <div
                    class="col-3 my-2 img-uploader-thumbnail"
                    v-for="video in videos"
                    :key="video.id"
                    v-on:click="selectVideo(video)"
                  >
                    <img
                      class="img-thumbnail"
                      :src="
                        mediaUrl +
                        '/' +
                        video.path +
                        '/frame1.jpg'
                      "
                      :alt="video.name"
                      v-on:error="onPosterError($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-end mt-4">
              <button class="btn btn-primary" v-on:click="save">
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import http from "../../modules/http";
const bootstrap = require("bootstrap");

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  name: "VideoUpload",
  props: {
    show: Boolean,
    value: null,
  },
  computed: {
    mediaUrl() {
      return process.env.VUE_APP_MEDIA_URL.replace("/images","/videos");
    },
  },
  data: function () {
    return {
      myModal: null,
      uploadMenu: true,
      myFiles: [],
      videos: [],
      server: {
        process: this.upload,
        revert: process.env.VUE_APP_MEDIA_API + "/videos/revert",
        restore: process.env.VUE_APP_MEDIA_API + "/videos/restore",
        load: process.env.VUE_APP_MEDIA_API + "/videos/load",
        fetch: process.env.VUE_APP_MEDIA_API + "/videos/upload/a",
      },
    };
  },
  watch: {
    show() {
      if(this.myModal === null) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      if (this.show) {
        if (this.videos.length < 1) {
          http.fetch("/videos").then((data) => {
            this.videos = data;
          });
        }
        this.myModal.show();
      }else{
        this.myModal.hide();
      }
    },
  },
  methods: {
    selectVideo(video) {
      let obj = Object.assign({},video);
      obj.path = this.mediaUrl+"/"+obj.path;
      this.$emit("select", obj);
    },
    upload(
      fieldName,
      file,
      metadata,
      load,
      error,
      progress,
      abort,
      transfer,
      options
    ) {
      console.log(fieldName);
      console.log(file);
      console.log(options);

      const _this = this;
      const request = new XMLHttpRequest();

      const id = Math.round(new Date() / 1000);
      let send = { type: "cover", id: id, videos: [file.name] };

      http.fetch("/files/upload", send).then((data) => {
        console.log(data);

        const formData = new FormData();
        formData.append("token", data.token);
        formData.append("album", id);
        formData.append("category", "cover");

        request.open("POST", process.env.VUE_APP_MEDIA_API + "/videos/upload");

        request.setRequestHeader("Upload-Length", file.size);
        request.setRequestHeader("Upload-Name", file.name);

        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, file.size);
        };

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            transfer(request.responseText);

            _this.chunkUpload(
              0,
              file,
              options,
              fieldName,
              data,
              progress,
              error,
              load,
              request.responseText
            );

          } else {
            error("oh no");
          }
        };

        request.send(formData);
      });

      return {
        abort: () => {
          request.abort();
          abort();
        },
      };
    },
    chunkUpload(
      start,
      file,
      options,
      fieldName,
      data,
      progress,
      error,
      load,
      fileId,
      i = 0
    ) {
      let _this = this;
      if (start < file.size) {
        let chunkEnd = Math.min(start + options.chunkSize, file.size);
        let chunkSize = chunkEnd - start;
        const chunk = file.slice(start, chunkEnd);

        const chunkForm = new FormData();
        chunkForm.append(fieldName, chunk, file.name);
        chunkForm.append("token", data.token);
        chunkForm.append("album", data.album);
        chunkForm.append("category", "cover");
        chunkForm.append("_method", "PATCH");

        const request = new XMLHttpRequest();

        request.open(
          "POST",
          process.env.VUE_APP_MEDIA_API + "/videos/upload/" + fileId
        );

        request.setRequestHeader("Upload-Offset", start);
        request.setRequestHeader("Upload-Length", chunkSize);
        request.setRequestHeader("Upload-Name", file.name);

        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, start + e.loaded, file.size);
        };

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            _this.chunkUpload(
              chunkEnd,
              file,
              options,
              fieldName,
              data,
              progress,
              error,
              load,
              fileId
            );
          } else {
            if (i >= options.chunkRetryDelays.length) {
              error("oh no");
            } else {
              setTimeout(() => {
                _this.chunkUpload(
                  start,
                  file,
                  options,
                  fieldName,
                  data,
                  progress,
                  error,
                  load,
                  fileId,
                  i + 1
                );
              }, options.chunkRetryDelays[i]);
            }
          }
        };

        request.send(chunkForm);
      } else {
        load();
        _this.uploaded(file.name);
      }
    },
    uploaded() {
      http.fetch("/videos").then((data) => {
        this.videos = data;
        this.selectVideo(data[data.length - 1]);
      });
    },
    onPosterError(e) {
      e.target.src = "/loading.gif";
    },
    save() {
      this.$emit("update:show", false);
    },
    handleFilePondInit: function () {
      console.log("FilePond has initialized");
    },
  },
  emits: ["update:show", "update:value"],
  components: { FilePond },
};
</script>
